import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  }
  
  render() {
    const { 
      onClick,
      props: {
        activeTab,
        label,
        image
      },
    } = this;

    let className = 'tab-list-item';

    if (activeTab === label) {
      className += ' tab-list-active';
    }

    return (
      <li key={`tab-${label}`} className={className} onClick={onClick}>
        { image !== '' && image !== undefined && <img src={image} alt={label} /> }
        {label}
      </li>
    );
  }
}


export default Tab;